import React from "react";
import { Link } from "react-router-dom";
import { FiPhoneCall, FiUsers, FiFileText } from "react-icons/fi";

const handleSmoothScroll = (targetId) => {
  const element = document.getElementById(targetId);
  if (element) {
    element.scrollIntoView({ behavior: "smooth" });
  }
};

const OverviewBlocks = () => {
  return (
    <div className="container mx-auto flex flex-col sm:flex-row items-stretch gap-10 mt-20">
      {/* Kontakt */}
      <Link
        to="/kontakt"
        className="flex-1 flex flex-col items-center justify-center p-4 border border-gray-200 rounded hover:bg-gray-100 transition-colors"
      >
        <FiPhoneCall className="text-3xl mb-2" />
        <p className="text-xl font-semibold">Kontakt</p>
        <p className="mt-1 text-center text-sm">
          Schreiben Sie uns oder rufen Sie uns an
        </p>
      </Link>

      {/* Ihre Berater - Smooth scroll to #anwaelte */}
      <button
        onClick={() => handleSmoothScroll("anwaelte")}
        className="flex-1 flex flex-col items-center justify-center p-4 border border-gray-200 rounded hover:bg-gray-100 transition-colors"
      >
        <FiUsers className="text-3xl mb-2" />
        <p className="text-xl font-semibold">Ihre Berater</p>
        <p className="mt-1 text-center text-sm">Lernen Sie unser Team kennen</p>
      </button>

      {/* Fachgebiete - Smooth scroll to #fachgebiete */}
      <button
        onClick={() => handleSmoothScroll("fachgebiete")}
        className="flex-1 flex flex-col items-center justify-center p-4 border border-gray-200 rounded hover:bg-gray-100 transition-colors"
      >
        <FiFileText className="text-3xl mb-2" />
        <p className="text-xl font-semibold">Fachgebiete</p>
        <p className="mt-1 text-center text-sm">
          Informieren Sie sich über unsere Bereiche
        </p>
      </button>
    </div>
  );
};

export default OverviewBlocks;
